export default __webpack_public_path__ + "static/media/logoNB.465a1dcd.png";